$(document).ready(function() {
	$('.cSliders .eMain .eSlider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 6000,
		arrows: false,
	})

	$('.cSliders .eDeals .eSlider').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		autoplay: true,
		vertical: true,
		infinite: true,
		autoplaySpeed: 2000,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 1,
					vertical: false,
					infinite: true,
					dots: true,
				}
			},
		]
	})

	$('.cHomeRanges .eBrands .eSlider').slick({
		slidesToShow: 6,
		slidesToScroll: 4,
		autoplay: true,
		arrows: false,
		infinite: true,
		autoplaySpeed: 2000,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: true,
				}
			},
		]
	})

	$('.cCategoryHead .eSlider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		infinite: true,
		dots: true,
	})

	$('.cProducts .eBrandSlider').slick({
		slidesToShow: 6,
		slidesToScroll: 3,
		autoplay: true,
		infinite: true,
		autoplaySpeed: 2000,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: true,
				}
			},
		]
	})

	$('.cFeatured .eSlider').slick({
		slidesToShow: 4,
		slidesToScroll: 4,
		autoplay: true,
		autoplaySpeed: 3000,
		infinite: true,
		dots: false,
		arrows: true,
	})


	$('.cUpsell .eSlider').slick({
		slidesToShow: 4,
		slidesToScroll: 4,
		autoplay: true,
		autoplaySpeed: 5000,
		infinite: true,
		dots: false,
		arrows: true,
	})

	$('.cProduct .eMainSlider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		infinite: true,
		dots: false,
		fade: true,
		arrows: false,
		asNavFor: '.cProduct .mSliderSync',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					arrows: true,
				}
			},
		]
	})

	$('.cProduct .eThumbSlider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: false,
		autoplaySpeed: 2000,
		infinite: true,
		focusOnSelect: true,
		arrows: true,
		asNavFor: '.cProduct .mSliderSync',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					vertical: true,
					arrows: true,
				}
			},
		]
	})

	$('.cProduct .eLightboxSlider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
		infinite: true,
		dots: false,
		fade: true,
		arrows: true,
		asNavFor: '.cProduct .mSliderSync',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					arrows: true,
				}
			},
		]
	})

	$('.cHomeBlog .eSlider').slick({
		slidesToShow: 2,
		slidesToScroll: 2,
		autoplay: false,
		infinite: true,
		dots: false,
		fade: true,
		arrows: false,
	})

	$('.cBlog .eSlider').slick({
		slidesToShow: 2,
		slidesToScroll: 2,
		autoplay: false,
		infinite: true,
		dots: false,
		fade: false,
		arrows: false,
	})
})
